export default __webpack_public_path__ + "static/media/logo.dc20272b.png";